export const STATUSES = {
  APPROVED: "Approved",
  PENDING: "Under Review",
  REJECTED: "Rejected"
};
